import React from "react";

import { ErrorBoundary } from "features/error-boundary";
import { LandingLayout } from "features/layouts/landing-layout/components";
import { Login } from "features/login/components";
import { Landing } from "features/landing/components";
import { About } from "features/about-us/components";
import { Register } from "../features/register/components";
import { VerifyOtpForm } from "../features/login/components/otp/verify-otp";
import { PhoneNumberForm } from "../features/login/components/otp/phone-number-form";
export const public_router = [
  {
    path: "/",
    element: <LandingLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      { path: "/", element: <Landing /> },

      { path: "/about-us", element: <About /> },
    ],
  },
  {
    path: "/",
    errorElement: <ErrorBoundary />,
    children: [{ path: "register", element: <Register /> }],
  },
  {
    path: "/login/verify",
    errorElement: <ErrorBoundary />,
    element: (
      <Login>
        <VerifyOtpForm />{" "}
      </Login>
    ),
  },
  {
    path: "login",
    errorElement: <ErrorBoundary />,
    element: (
      <Login>
        <PhoneNumberForm />{" "}
      </Login>
    ),
  },
  { path: "/error-unauthorize", element: <ErrorBoundary /> },
];
